/* Nerpy's free-shipping message for cart drawer + cart page (Ontario $65+) */
(function () {
  var THRESHOLD = 6500; // cents
  var SUB = 'Ontario $9.99 · Rest of Canada from $17.99 · Free on Ontario orders $65+';
  var css = document.createElement('style');
  css.textContent =
    '.fsm{margin:0 0 1rem;padding:.8rem 1rem;border-radius:.6rem;background:rgba(var(--color-foreground),.06);font-size:1.4rem;line-height:1.4;text-align:center}' +
    '.fsm-sub{font-size:1.2rem;opacity:.75;margin-top:.3rem}';
  document.head.appendChild(css);

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function html(total) {
    var left = THRESHOLD - total;
    var main = left > 0
      ? 'Add ' + money(left) + ' more for free shipping in Ontario 🚚'
      : 'You’ve unlocked free shipping in Ontario! 🎉';
    return '<strong>' + main + '</strong><div class="fsm-sub">' + SUB + '</div>';
  }
  function place(cart) {
    ['#CartDrawer .cart__ctas', '#main-cart-footer .cart__ctas'].forEach(function (sel) {
      var ctas = document.querySelector(sel);
      if (!ctas) return;
      var el = ctas.parentNode.querySelector(':scope > .fsm');
      if (!cart.item_count) { if (el) el.remove(); return; }
      if (!el) { el = document.createElement('div'); el.className = 'fsm'; ctas.parentNode.insertBefore(el, ctas); }
      var h = html(cart.total_price);
      if (el.innerHTML !== h) el.innerHTML = h;
    });
  }
  var busy = false, again = false, timer;
  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(place)
      .catch(function () {})
      .finally(function () { busy = false; if (again) { again = false; refresh(); } });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 250); }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (!t.closest || t.closest('.fsm')) continue;
      if (t.closest('#CartDrawer') || t.closest('#main-cart-footer') || t.id === 'CartDrawer') { schedule(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
